import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../../../../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../../../../../../../components/typography/MuiTypography.style";

export const ProjectViewDeliverablesWrapper = styled.div`
  padding: 24px 0px 24px 16px;
  .MuiGrid2-root {
    padding-right: 18px;
    margin-top: 40px;

    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}
    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 24px;
        }
    `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }

  .view-locale-link {
    ${h3Regular}
    ${fontWeightBold}
    text-decoration: underline;
    color: ${COLORS.primary_light_blue};
  }

  .deliverable-value {
    max-width: 200px;
  }
`;
